import React from 'react';
import RotatingText from './component/RotatingText';

const PageLoader = () => {
  return (
    <div className="flex justify-center items-center h-full min-h-screen w-full">
      <RotatingText
        texts={['Loading...', 'Please Wait...', 'Almost There...']}
        prefix=""
        mainClassName="text-[#232e57] text-xl sm:text-2xl font-semibold tracking-wider"
        staggerFrom="last"
      />
    </div>
  );
};

export default PageLoader;
